<template>
    <div id="message">
        <top :topIndex="5"></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left :leftIndex="5"></left>
            <div class="contactUs">
                <div class="flex" style="height: 100%;">
                    <ClassroomList />
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import ClassroomList from '@/components/classroom/list.vue' //列表
import { EventBus } from '@/utils/eventBus'
export default {
    components: {
        top, left, ClassroomList
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
            ifDetail: 0, //0列表 1详情
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        toDetail(id) {
            this.ifDetail = 1
            EventBus.$emit('dynamicsDetail', id)
        },
        goBack() {
            this.ifDetail = 0
        }
    }
}
</script>

<style lang="scss" scoped>
#message {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.contactUs {
    width: 100%;
    margin: 17px 37px 22px 19px;
    background: #FFFFFF;
    border-radius: 10px;
    flex: 1;
    overflow: auto;
    @include scrollbar(none);
}
</style>